import {
	InitialAccountDataStorageKey,
	StaffPermissionsLevelStorageKey,
	CreateHQDataStorageKey,
	DefaultRegionStorageKey,
	DeviceTypeStorageKey,
	SeatCountStorageKey,
	AutomationCompleted
} from "../constants/localStorage";


export function getAutomationDataFromLocalStorage() {
	if (
		localStorage.getItem(InitialAccountDataStorageKey) &&
		localStorage.getItem(CreateHQDataStorageKey) &&
		localStorage.getItem(StaffPermissionsLevelStorageKey) &&
		localStorage.getItem(DefaultRegionStorageKey)
	) {
		const initialAccountData = JSON.parse(localStorage.getItem(InitialAccountDataStorageKey));
		const hqData = JSON.parse(localStorage.getItem(CreateHQDataStorageKey));
		const defaultCountry = parseInt(localStorage.getItem(DefaultRegionStorageKey));
        const permissionSelected = localStorage.getItem(StaffPermissionsLevelStorageKey);

		let combinedData = Object.assign({}, initialAccountData, hqData);
		combinedData.permissionLevel = permissionSelected?.replace("Level ", "");
		combinedData.seatCount = 0; // Will be updated by the caller
		combinedData.defaultCountry = defaultCountry;

		var dataModel = {
			...combinedData,
			phoneNumber: combinedData.phone,
			zip: combinedData.zipcode,
		};
		return dataModel;
	}
	return null;
}
export function clearAutomationDataFromLocalStorage() {
	[InitialAccountDataStorageKey, StaffPermissionsLevelStorageKey, CreateHQDataStorageKey, DeviceTypeStorageKey, SeatCountStorageKey, DefaultRegionStorageKey].forEach((item) => localStorage.removeItem(item));
}

export function markAutomationCompleted(confirmationPageUrl) {
	clearAutomationDataFromLocalStorage();
    localStorage.setItem(AutomationCompleted, confirmationPageUrl);
}
export function isAutomationCompleted() {
    return localStorage.getItem(AutomationCompleted) ? true : false;
}